/**
 * MemberSegmentsByTenureChart — NOT_CONNECTED
 *
 * Tenure/segment data requires CRM integration.
 * Renders DataSourceNotConnected placeholder.
 */
import React from 'react';
import DataSourceNotConnected from './DataSourceNotConnected';
import { NOT_CONNECTED_REGISTRY } from '../../../types/insightsTypes';

const MemberSegmentsByTenureChart: React.FC = () => {
  return (
    <DataSourceNotConnected
      info={NOT_CONNECTED_REGISTRY.crm}
      metricName="Members by Length of Membership"
    />
  );
};

export default MemberSegmentsByTenureChart;